import { P0, S, abs, earShape, fillAt, max, sq } from '../../geometry';

export const pup = {
  name: 'Pup',
  colors: ['#C46A3E', '#161616'],
  draw(m, t) {
    let lL = 3 * S(t * 1.4),
      lR = 3 * S(t * 1.4 + 0.6),
      pose = P0();
    if (m === 'happy') {
      lL = 20 + 18 * S(t * 9);
      lR = 20 + 18 * S(t * 9 + 0.5);
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: head tilts while the ears take turns lifting.
    if (m === 'thinking') {
      pose.rot = 5 * S(t * 1.2);
      lL = 34 * max(0, S(t * 2.4));
      lR = 34 * max(0, -S(t * 2.4));
    }
    if (m === 'talking') lL = lR = 10 * max(0, S(t * 10));
    if (m === 'surprised') lL = lR = 62;
    if (m === 'paused') {
      lL = lR = -10;
      pose.sy = 0.94;
      pose.ty = 2;
    }
    const L = earShape(29, 42, -150 + lL, -22, 27, 8),
      Rr = earShape(71, 42, 150 - lR, 22, 27, 8);
    return {
      strokes: [
        { c: 'b', pts: L.outline, n: 24 },
        { c: 'b', pts: Rr.outline, n: 24 },
        { c: 'a', pts: sq(50, 58, 24, 22, 2.7), n: 28 },
      ],
      eyes: { x: 50, y: 59 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1, 2),
};
